import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from 'styled-components';
import ErrorBoundary from '../components/ErrorBoundry/errorBoundry';
import theme from '../theming/themeProvider';
import {AppContextProvider} from './contextProvider';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
            // useErrorBoundary: true,
            refetchOnMount: 'always',
        },
        mutations: {
            retry: false,
        }
    }
})


const AppProvider = ({children}) => <QueryClientProvider client={queryClient}>
    <ErrorBoundary>
        <AppContextProvider>
            <ThemeProvider theme={theme} >{children}</ThemeProvider>
        </AppContextProvider>
    </ErrorBoundary>
</QueryClientProvider>

export default AppProvider;